// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"cd19898b","194":"29ea017d","741":"505b18f5","845":"445c9669","950":"82ea04f2","972":"55cd1e2f"}[chunkId] + ".chunk.js";
};